import script from "./ChoixRegimePersonnalise.vue?vue&type=script&setup=true&lang=js"
export * from "./ChoixRegimePersonnalise.vue?vue&type=script&setup=true&lang=js"

import "./ChoixRegimePersonnalise.vue?vue&type=style&index=0&id=775c861c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-775c861c"]])

export default __exports__